import { TextField, Tooltip } from "@material-ui/core";
import React from "react";
import { createRef } from "react";
import { connect } from "react-redux";
import { appActions, userActions } from "../_actions";
import { EditButton } from "../_components/buttons/EditButton";
import { store, normalizeUrl, normalizePremiumState, intlLocale } from "../_helpers";
import { confService, userService } from "../_services";
import "../css/style.css";
import confLogo from "../img/conf_logo.png";
import CopyContentIcon from "@material-ui/icons/FileCopy";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import "react-quill/dist/quill.snow.css";

import MenuItem from "@mui/material/MenuItem";
import { ConferenceNotSelected } from "../_components/ConferenceNotSelected";
import { AILandingPage } from "../AILanding/AILandingPage";
import SponsorDialog from "./SponsorDialog";

import DeleteIcon from "@material-ui/icons/Delete";

import Select from "@mui/material/Select";
import i18next from "i18next";
import InputI18N from "../_components/InputI18N";
import Collapsed from "../_components/Collapsed";
import LabelHint from "../_components/LabelHint";
import TextAreaI18N from "../_components/TextAreaI18N";
import { serverUrl, landingDomain, currencySymbol, lhcUrl } from "../_constants";
import BldDialog from "./BldDialog";
import DropFile from "../_components/DropFile";
import RequisitesDialog from "../_components/RequisitesDialog/RequisitesDialog";
import TabEditor from "../_components/TabEditor";
import TranslationSettings from "../_components/Translation/TranslationSettings";
import TicketTypeList from "./TicketType/TicketTypeList";
import { buildTicketTypePayload, hasTicketName } from "./TicketType/TicketTypeItem";
import ConfItem from "./ConfItem";

class CreateConfPage extends React.Component {
  constructor(props) {
    super(props);
    this.afterAddActions = {};

    this.state = {
      activeTab: 0,
      showCardPreview: false,
      value: "one",
      isOpen: false,
      loadingTickets: false,
      streamUrl: "",
      sponsors: [],
      sp_list: [],
      tickets: [],
      tickets_tmp: [],
      name: "",
      name_i18n: {},
      id: 0,
      theme: "",
      date: "3",
      adress: "4",
      part_count: "0",
      spons_count: "0",
      start_date: null,
      end_date: null,
      start_time: "10:00",
      end_time: "18:00",
      blds: [],
      selectedBldId: 0,
      bldAddr: "",
      bldDialog: false,
      bldId: 0,
      spId: 0,
      spDialog: false,
      dName: "",
      dNameI18N: {},
      dDesc: "",
      dDescI18N: {},
      hidden_without_tickets: 0,
      questionable: 1,
      online_support: 1,
      dAddress: "",
      dEmail: "",
      format: "hybrid",
      contacts: "",
      contacts_i18n: {},
      wifi: "",
      wifi_i18n: {},
      external_ticket_url: "",
      ai_text: "",
      faq: "",
      description: "",
      description_i18n: {},
      urlt: "",
      is_published: 0,
      brief: "",
      brief_id: 0,
      langList: [],
      allLang: {
        ru: i18next.t("lang_ru"),
        en: i18next.t("lang_en"),
        cn: i18next.t("lang_cn"),
      },
      confLimits: null,
      premiumState: "",
      isMultilang: false,
      allAnketaFields: [],
      createTranslationForNewConference: 0,
      translation: null,
      showRequisitesDialog: false,
      pendingPublish: 0,
      requiredFields: null,
    };

    this.editorRef = createRef();
  }

  clickLangItem = (item) => {
    let { langList, name } = this.state;

    const oldLangLength = langList.length;

    if (langList.indexOf(item) >= 0) {
      //if (item != "ru")
      langList = langList.filter((e) => e != item);
    } else {
      langList.push(item);
    }

    langList = langList.sort((a, b) => {
      if (a == "ru" && b == "en") return -1;
      if (a == "ru" && b == "cn") return -1;
      if (a == "en" && b == "cn") return -1;

      return 1;
    });

    if (oldLangLength == 0 && langList.length > 0 && name != "") {
      const name_i18n = { ru: name, en: name, cn: name };
      this.setState({ langList, isMultilang: langList.length > 0, name_i18n });
    } else this.setState({ langList, isMultilang: langList.length > 0 });
  };

  getAllAnketaFields = () => {
    userService.getWrapper(
      "api/anketafield",
      (data) => {
        this.setState({ allAnketaFields: data.data });
      },
      (error) => {
        console.log(error);
      }
    );
  };

  storeChange = () => {
    const { dispatch } = this.props;

    if (store.getState().user.isLoading === false) {
      if (store.getState().user.error === "") {
        dispatch(appActions.setpage("conf_list"));
      }
    }
  };

  componentDidMount() {
    const { selectedConf } = this.props.user;

    this.setState({
      lang: this.props.app.lang,
    });

    if (!(selectedConf && selectedConf.id)) {
      this.props.dispatch(appActions.setpage("new_conf"));
    }

    if (selectedConf && selectedConf.id) {
      this.getTickets(selectedConf.id);
      this.getBuildings(selectedConf.building_id);
      this.getConfInfo(selectedConf.id);
      this.getLimitInfo(selectedConf.id);
    } else {
      this.getBuildings();
      const defaultName = i18next.t("default_ticket_name");
      this.setState({
        tickets_tmp: [{
          id: 0,
          name: defaultName,
          name_i18n: {
            ru: i18next.getFixedT("ru")("default_ticket_name"),
            en: i18next.getFixedT("en")("default_ticket_name"),
            cn: i18next.getFixedT("cn")("default_ticket_name"),
          },
          cost: 0,
          exponent: false,
          required_anketa: [],
          optional_anketa: [],
        }],
      });
    }

    this.getSponsors(0);
    this.getAllAnketaFields();
  }

  componentWillReceiveProps(nextProps) {
    const { selectedConf } = this.props.user;

    if (nextProps.app.lang !== this.state.lang) {
      this.setState({ lang: nextProps.app.lang });

      if (selectedConf && selectedConf.id) {
        this.getBuildings(selectedConf.building_id);
      } else this.getBuildings();
      this.getSponsors(0);
    }
  }

  // Лимиты тарифа для раздела «Ограничения мероприятия». Статус опции «Без
  // ограничений» приходит отдельно, в поле canBePremium конференции.
  getLimitInfo = (id) => {
    userService.getWrapper(
      "api/tariff/restriction/conference/" + id,
      (data) => {
        const keys = Object.keys(data.data);
        const result =
          keys.length > 0
            ? keys.map(function (key) {
                const max = data.data[key]["max"] ?? i18next.t("unlimited");
                return (
                  <div>
                    {key}: {data.data[key]["current"] ?? 0} / {max}
                  </div>
                );
              })
            : i18next.t("unlimited");
        this.setState({ confLimits: <div>{result}</div> });
      },
      (error) => {
        console.log(error);
      }
    );
  };

  setConfToState(confData) {
    let langList = confData.languages;

    if (!langList) langList = ["ru"];

    langList = langList.sort((a, b) => {
      if (a == "ru" && b == "en") return -1;
      if (a == "ru" && b == "cn") return -1;
      if (a == "en" && b == "cn") return -1;

      return 1;
    });

    let tmpObj = {};
    let field_list = ["name", "faq", "contacts", "description", "wifi"];

    for (let item of field_list) {
      tmpObj[item + "_i18n"] = confData[item + "_i18n"];
    }

    for (let key of Object.keys(tmpObj)) {
      console.log(key, tmpObj[key]);

      if (!tmpObj[key]) {
        let new_key = key.replace("_i18n", "");

        tmpObj[key] = {};

        for (let item in this.state.allLang) {
          if (langList.includes(item)) {
            tmpObj[key][item] = confData[new_key];
          } else {
            tmpObj[key][item] = "";
          }
        }
      }
    }

    let oldObj = {
      id: confData.id,
      name: confData.name,
      format: confData.type,
      description: confData.description,
      streamUrl: confData.navigation_description,
      id: confData.id,
      faq: confData.faq,
      wifi: confData.wifi,
      contacts: confData.contacts,
      is_published: confData.is_published == "draft" ? 0 : 1,
      image: confData.image,
      start_date: confData.start_time
        ? confData.start_time.substr(0, 10)
        : null,
      end_date: confData.end_time ? confData.end_time.substr(0, 10) : null,
      start_time: confData.start_time
        ? confData.start_time.substr(11, 5)
        : null,
      end_time: confData.end_time ? confData.end_time.substr(11, 5) : null,
      selectedBldId: confData.building_id,
      part_count: confData.participants_count,
      sp_list: confData.sponsors,
      spons_count: confData.sponsors_count,
      langList: langList,
      hidden_without_tickets: confData.hidden_without_tickets,
      questionable: confData.questionable,
      online_support: confData.online_support,
      premiumState: normalizePremiumState(confData.canBePremium, confData.premium),
      isMultilang: langList.length > 0,
      translation: confData.translation,
      urlt: confData.url,
      domain: confData.domain,
      metrics: confData.metrics,
      external_ticket_url: confData.external_ticket_url ?? "",
      ai_text: confData.ai_text ?? "",
    };

    for (let field of field_list)
      oldObj[field + "_i18n"] = tmpObj[field + "_i18n"];

    this.setState(oldObj);

    let brief_docs = confData.documents.filter(
      (e) => e.type == "presentation_template"
    );

    if (brief_docs.length > 0) {
      this.setState({
        brief_id: brief_docs[0].id,
        brief: brief_docs[0].description,
      });
    }
  }

  getBrief = () => {};

  saveScheduleDoc = (conf_id) => {};

  saveHintDoc = (conf_id) => {
    let { id, brief, brief_id } = this.state;
    if (conf_id) id = +conf_id;
  };

  saveBrief = (conf_id = undefined) => {
    const { dispatch } = this.props;

    let { id, brief, brief_id } = this.state;

    if (conf_id) id = +conf_id;

    if (id >= 0 && brief) {
      let post_data = {
        documentable_id: id,
        documentable_type: "conference",
        type: "presentation_template",
        description: brief,
        access: "team",
        link: `https://${landingDomain}/`,
      };

      if (brief_id > 0) {
        post_data.id = brief_id;
      }

      userService.postWrapper(
        "api/document",
        post_data,
        () => {},
        (error) => {
          if (error !== "") {
            //dispatch(userActions.set_error(i18next.t("cant_execute_request")));
          }
        }
      );
    }

    if (id >= 0 && brief == "" && brief_id) {
      userService.delWrapper(
        "api/document/" + brief_id,
        (data) => {
          console.log(data);
        },
        (error) => {
          if (error !== "") {
            //dispatch(userActions.set_error(i18next.t("cant_execute_request")));
          }
        }
      );
    }
  };

  getConfInfo = (id, is_save = false) => {
    const self = this;
    const { dispatch } = this.props;

    confService.confInfo(
      id,
      (data) => {
        if (data.status === 200) {
          self.setConfToState(data.data);

          dispatch(userActions.set_conf({ ...data.data }));
        }
      },
      (error) => {
        //dispatch(userActions.set_error(i18next.t("cant_execute_request")));
      }
    );
  };

  editSponsors = () => {
    const { id } = this.state;

    this.setState({ spId: id, spDialog: true });
  };

  resetConf = () => {
    const { brief_id } = this.state;

    // Бриф хранится отдельным документом на сервере — при сбросе удаляем и его,
    // иначе «сброшенная» форма после сохранения вернёт старый файл.
    if (brief_id > 0) {
      userService.delWrapper(
        "api/document/" + brief_id,
        () => {},
        () => {}
      );
    }

    this.afterAddActions = {};
    this.setState({
      name: "",
      name_i18n: {},
      langList: [],
      isMultilang: false,
      format: "hybrid",
      // Пустые строки, а не null: контролируемый input при переходе value в null
      // становится uncontrolled и не очищает видимое поле.
      start_date: "",
      end_date: "",
      start_time: "",
      end_time: "",
      selectedBldId: 0,
      wifi: "",
      wifi_i18n: {},
      description: "",
      description_i18n: {},
      faq: "",
      contacts: "",
      contacts_i18n: {},
      streamUrl: "",
      urlt: "",
      external_ticket_url: "",
      ai_text: "",
      image: null,
      tickets_tmp: [],
      brief: "",
      brief_id: 0,
    });
  };

  setPremium = () => {
    const { id } = this.state;
    const { classes, dispatch } = this.props;
    let self = this;

    userService.postWrapper(
      "api/conference/" + id + "/premium",
      {},
      () => {
        self.getConfInfo(id);
        self.getLimitInfo(id);
      },
      (error) => {
        if (error !== "") {
          //dispatch(userActions.set_error(i18next.t("cant_execute_request")));
        }
      }
    );
  };

  // Дата окончания опции «Без ограничений» (premiumState.until, ISO с бэка).
  premiumUntilDate = () => {
    const until = this.state.premiumState && this.state.premiumState.until;
    if (!until) return "";
    return new Intl.DateTimeFormat(intlLocale(), {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(new Date(until));
  };

  goToFinance = () => {
    // Вкладку задаём до setpage: иначе SettingsPage смонтируется со старым значением.
    this.props.dispatch(appActions.setSettingsTab(2));
    this.props.dispatch(appActions.setpage("settings"));
  };

  // «Недостаточно средств…» с ссылкой на раздел «Финансы» — одна i18n-строка с %s
  // (склейка отдельных ключей даёт лишние пробелы в китайском). card__link не
  // годится: он display:flex и в предложении уводит текст на отдельные строки.
  lowBalanceHint = () => {
    const parts = i18next.t("premium_low_balance_hint").split("%s");
    return (
      <>
        {parts[0]}
        <a onClick={this.goToFinance} style={{ textDecoration: "underline" }}>
          {i18next.t("finances")}
        </a>
        {parts[1]}
      </>
    );
  };


  onDrop = (acceptedFiles, rejectedFiles) => {
    if (acceptedFiles.length > 0) {
      this.uploadFile(acceptedFiles[0]);
    }
  };

  uploadFile(selectedFile) {
    const self = this;
    const { dispatch } = this.props;
    const data_upload = new FormData();
    data_upload.append("image", selectedFile);
    const uploader = () =>
      userService.uploadFile(
        `api/conference/${this.state.id}/upload`,
        data_upload,
        (data) => {
          if (data && data.data && data.data.image)
            self.setState({ image: data.data.image });

          //dispatch(userActions.set_error(i18next.t("cant_execute_request")));
        },
        (error) => {
          //dispatch(userActions.set_error(i18next.t("cant_execute_request")));
        }
      );
    if (this.state.id > 0) {
      uploader();
    } else {
      this.afterAddActions["uploader"] = uploader;
      self.setState({ image: URL.createObjectURL(selectedFile) });
    }
  }

  createPendingTickets = (newConferenceId) => {
    const { tickets_tmp, isMultilang } = this.state;
    const pending = (tickets_tmp || []).filter((t) => !t.id && hasTicketName(t, isMultilang));
    if (pending.length === 0) return;

    let remaining = pending.length;
    pending.forEach((ticket) => {
      const post_data = buildTicketTypePayload(ticket, newConferenceId, isMultilang);
      userService.postWrapper(
        "api/ticket-type",
        post_data,
        () => {
          remaining -= 1;
          if (remaining === 0) this.getTickets(newConferenceId);
        },
        () => {
          remaining -= 1;
          if (remaining === 0) this.getTickets(newConferenceId);
        }
      );
    });
  };

  getTickets = id => {
    let self = this;
    const { dispatch } = this.props;

    if (id > 0) {
      this.setState({ loadingTickets: true });

      confService.ticketsInfo(
        id, 1,
        data => {
          if (data.data) {
            let tmp_data = [...data.data];
            tmp_data = tmp_data.map((item) => ({
              ...item,
              name: item.name,
              name_i18n: item.name_i18n ?? { ru: item.name, en: "", cn: "" },
              cost: item.cost ? item.cost : 0,
              exponent: item.exponent,
              form: item.form,
              required_anketa: item.required_anketa,
              optional_anketa: item.optional_anketa,
            }));
            self.setState({ tickets_tmp: tmp_data, loadingTickets: false });
          } else {
            self.setState({ tickets_tmp: [], loadingTickets: false });
          }
        },
        error => {
          dispatch(userActions.set_error(error));
        }
      );
    }
  };

  getSponsors = (id) => {
    let self = this;
    const { classes, dispatch } = this.props;

    let getUrl = "api/sponsor";
    if (id > 0) getUrl += `?conference_id=${id}`;

    userService.getWrapper(
      getUrl,
      (data) => {
        if (id > 0) {
          if (data.data)
            self.setState({
              sponsors: [...data.data],
              spons_count: `${data.data.length}`,
            });
          else self.setState({ sponsors: [] });
        } else if (data.data) self.setState({ sp_list: [...data.data] });
        else self.setState({ sp_list: [] });
      },
      (error) => {
        if (error != "") {
          self.setState({ error });
          dispatch(userActions.set_error(error, "error"));
        }
      }
    );
  };

  setBld = (id) => {
    let addr = "";
    const { blds } = this.state;

    for (let i = 0; i < blds.length; i++)
      if (blds[i].id == id) addr = blds[i].address;

    this.setState({ selectedBldId: id, bldAddr: addr });
  };

  getBuildings = (id = 0) => {
    let self = this;

    userService.getWrapper(
      "api/building",
      (data) => {
        if (data.data) {
          if (id > 0) {
            let addr = "";
            for (let i = 0; i < data.data.length; i++) {
              if (data.data[i].id == id) {
                addr = data.data[i].address;
                break;
              }
            }
            self.setState({
              blds: [...data.data],
              bldAddr: addr,
              selectedBldId: id,
            });
          } else self.setState({ blds: [...data.data] });
        }
      },
      (error) => {
        if (error != "") {
          self.setState({ error, isLoading: false });
        }
      }
    );
  };

  setConfData = () => {
    const { dispatch } = this.props;

    let {
      name,
      start_date,
      end_date,
      start_time,
      end_time,
      selectedBldId,
      faq,
      wifi,
      contacts,
      format,
      id,
      langList,
      name_i18n,
      contacts_i18n,
      faq_i18n,
      wifi_i18n,
      description_i18n,
      description,
      hidden_without_tickets,
      questionable,
      online_support,
      domain,
      metrics,
      external_ticket_url,
      ai_text,
    } = this.state;

    let selectedBldOk = true;

    if (format !== "online" && !selectedBldId) selectedBldOk = false;

    if (
      (!name && !name_i18n["ru"]) ||
      !(start_date && end_date && selectedBldOk)
    ) {
      let tmp_str = i18next.t("fill_fields_name_dates");

      if (format !== "online" && !selectedBldId)
        tmp_str += ", " + i18next.t("select_bld");

      dispatch(userActions.set_error(tmp_str, "warning"));

      return;
    }

    if (!name) {
      name = name_i18n["ru"];
    }

    let tmp_start_time = "09:00";
    let tmp_end_time = "18:00";

    if (start_time) tmp_start_time = start_time;

    if (end_time) tmp_end_time = end_time;

    const endDate = new Date(end_date + "T" + tmp_end_time + ":00.000Z");
    let curDate = new Date();
    curDate.setDate(curDate.getDate() - 1);
    const startDate = new Date(start_date + "T" + tmp_start_time + ":00.000Z");

    if (endDate < startDate) {
      dispatch(
        userActions.set_error(i18next.t("start_end_date_text"), "warning")
      );

      return;
    }

    if ((id == 0 && curDate > startDate) || (id > 0 && curDate > endDate)) {
      dispatch(
        userActions.set_error(i18next.t("start_date_in_past_text"), "warning")
      );
      return;
    }
    const post_obj = {
      name: name,
      name_i18n: name_i18n,
      start_time: start_date + "  " + tmp_start_time + ":00",
      end_time: end_date + "  " + tmp_end_time + ":00",
      description: description,
      description_i18n,
      faq: faq,
      faq_i18n,
      wifi: wifi,
      wifi_i18n,
      contacts: contacts,
      contacts_i18n,
      type: format,
      languages: langList,
      hidden_without_tickets,
      questionable,
      online_support,
      create_translation: this.state.createTranslationForNewConference,
      // Схему в адресах дописываем здесь, а не в onChange поля: пока человек
      // печатает, подставленный «https://» прыгал бы в курсор.
      url: normalizeUrl(this.state.urlt),
      domain,
      metrics,
      external_ticket_url: normalizeUrl(external_ticket_url),
      ai_text,
    };

    if (selectedBldId) post_obj.building_id = selectedBldId;

    return { ...post_obj };
  };

  saveConf = (is_publish = 0) => {
    let self = this;
    const { dispatch } = this.props;
    const { tickets_tmp } = this.state;

    let post_obj = this.setConfData();

    if (!post_obj) {
      return;
    }

    if (is_publish == 1 && tickets_tmp.length > 0) {
      let isFail = false;
      for (let i = 0; i < tickets_tmp.length; i++)
        if (tickets_tmp[i].name === "") isFail = true;

      if (isFail) {
        dispatch(
          userActions.set_error(
            i18next.t("tickets_name_cant_be_empty"),
            "warning"
          )
        );
        return;
      }
    }

    // -1 — обычное сохранение: поле не шлём, и бэк публикацию не трогает
    // (раньше уходил 0, и «Сохранить мероприятие» снимало его с публикации).
    if (is_publish >= 0) post_obj.is_published = is_publish;

    console.log(post_obj);

    userService.patchWrapperBody(
      `api/conference/${this.state.id}`,
      post_obj,
      (data) => {
        console.log("SAVE", post_obj);
        const tmp_str = i18next.t("changes_saved");
        dispatch(userActions.set_error(tmp_str, "success"));

        self.getConfInfo(self.state.id, true);
      },
      (error) => {
        const changes =
          error &&
          error.response &&
          error.response.data &&
          error.response.data.required_changes;
        if (changes && Array.isArray(changes.requisites)) {
          self.setState({
            showRequisitesDialog: true,
            pendingPublish: is_publish,
            requiredFields: changes.requisites,
          });
          return;
        }
        dispatch(userActions.set_error(error, "error"));
      }
    );

    this.saveBrief();
  };

  addConf = (is_publish = 0) => {
    const self = this;
    const { classes, dispatch } = this.props;
    const { selectedBldId } = this.state;

    let post_obj = this.setConfData();

    if (!post_obj) return;

    if (selectedBldId) post_obj.building_id = selectedBldId;

    userService.postWrapper(
      "api/conference",
      post_obj,
      (data) => {
        if (data.data && data.data > 0) {
          self.setState({ id: data.data, is_published: is_publish });
          self.getConfInfo(self.state.id, true);
          self.saveBrief(data.data);
          self.getLimitInfo(self.state.id);
          self.createPendingTickets(data.data);
          for (let action of Object.keys(this.afterAddActions)) {
            this.afterAddActions[action]();
          }
        } else {
          const tmp_str = i18next.t("changes_saved");
          dispatch(userActions.set_error(tmp_str, "success"));
          self.getConfInfo(self.state.id, true);
        }
      },
      (error) => {
        dispatch(userActions.set_error(error));
      }
    );
  };

  onPublic = (n) => {
    const { id } = this.state;
    const { classes, dispatch } = this.props;

    if (id > 0) this.saveConf(n);
    else
      dispatch(
        userActions.set_error(i18next.t("need_save_before_public"), "warning")
      );
    //this.addConf(n);
  };

  onAdd = () => {
    this.addConf();
  };

  onSave = () => {
    this.saveConf(-1);
  };

  getPreviewText = (value, fallback = "") => {
    if (typeof value === "string") return value.trim() ? value : fallback;
    if (value && typeof value === "object") {
      const { langList } = this.state;
      const currentLang =
        localStorage.getItem("navic_lang") || i18next.language || "ru";
      const orderedLangs = [
        currentLang,
        ...(langList || []),
        "ru",
        "en",
        "cn",
      ];
      for (let i = 0; i < orderedLangs.length; i++) {
        const lang = orderedLangs[i];
        if (value[lang]) return value[lang];
      }
    }
    return fallback;
  };

  getPreviewCardData = () => {
    const {
      id,
      image,
      format,
      name,
      name_i18n,
      isMultilang,
      start_date,
      end_date,
      start_time,
      end_time,
      selectedBldId,
      blds,
      is_published,
      part_count,
      spons_count,
      sponsors,
    } = this.state;

    const previewName = this.getPreviewText(
      isMultilang ? name_i18n : name,
      i18next.t("event_name")
    );
    const selectedBuilding = (blds || []).find(
      (item) => item.id == selectedBldId
    );
    const startDate = start_date || new Date().toISOString().substr(0, 10);
    const endDate = end_date || startDate;
    const startTime = start_time || "10:00";
    const endTime = end_time || "18:00";

    return {
      id: id || 0,
      image,
      type: format || "hybrid",
      name: previewName,
      is_published: is_published == 1 ? "published" : "draft",
      start_time: `${startDate} ${startTime}:00`,
      end_time: `${endDate} ${endTime}:00`,
      building_id: selectedBuilding || null,
      tickets_count: part_count || 0,
      sponsors_count: spons_count || (sponsors ? sponsors.length : 0),
    };
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  descChange = (val, tabName) => {
    const { isMultilang } = this.state;

    console.log(val);

    let tmpObj = this.state["description_i18n"] ?? {};
    tmpObj = { ...tmpObj };
    tmpObj[tabName] = val;

    if (isMultilang) {
      this.setState({ description_i18n: tmpObj });
    } else {
      this.setState({ description: val });
    }
  };

  handleChangeI18N = (event, tabName) => {
    const { isMultilang } = this.state;

    let tmpObj = this.state[event.target.name + "_i18n"] ?? {};
    tmpObj = { ...tmpObj };
    tmpObj[tabName] = event.target.value;

    if (isMultilang) {
      this.setState({ [event.target.name + "_i18n"]: tmpObj });
    } else {
      console.log(event.target.value, event.target.name);
      this.setState({ [event.target.name]: event.target.value });
    }
  };

  changeDate = (index, event) => {
    if (index == 0) this.setState({ start_date: event.target.value });
    else this.setState({ end_date: event.target.value });
  };

  changeTime = (index, event) => {
    if (index == 0) this.setState({ start_time: event.target.value });
    else this.setState({ end_time: event.target.value });
  };

  handleChangeAdress = (index, col, event) => {
    /*
        let { blds } = this.state;
        let tmp_item = adresses[index];
        tmp_item[col] = event.target.value;
        adresses[index] = {...tmp_item}
        this.setState({adresses:adresses});
        */
  };

  deleteAddr = (id) => {
    const self = this;
    const { selectedBldId } = this.state;
    const { dispatch } = this.props;

    if (selectedBldId > 0) {
      userService.delWrapper(
        `api/building/${selectedBldId}`,
        function (data) {
          if (data.status == 200) self.getBuildings();
        },
        function (error) {
          if (error != "") {
            self.setState({ error: error, isLoading: false });
            dispatch(userActions.set_error(error, "error"));
          }
        }
      );
    }
  };

  editAddr = (id) => {
    const { blds } = this.state;
    let bldAddr = "";
    let bldName = "";
    let bldEmail = "";
    let bldDesc = "";
    let bldNameI18N = {};
    let bldDescI18N = {};
    for (let i = 0; i < blds.length; i++) {
      if (blds[i].id == id) {
        bldAddr = blds[i].address;
        bldName = blds[i].name;
        bldEmail = blds[i].email;
        bldDesc = blds[i].description;
        bldNameI18N = blds[i].name_i18n;
        bldDescI18N = blds[i].description_i18n;
      }
    }

    this.setState({
      bldId: id,
      dAddress: bldAddr,
      dName: bldName,
      dEmail: bldEmail,
      dDesc: bldDesc,
      dNameI18N: bldNameI18N,
      dDescI18N: bldDescI18N,
      bldDialog: true,
    });
  };

  addAddr = () => {
    this.setState({
      bldId: 0,
      dAddress: "",
      dName: "",
      dNameI18N: {},
      dDescI18N: {},
      dDesc: "",
      dEmail: "",
      bldDialog: true,
    });
  };

  closeSpDialog = () => {
    this.setState({ spId: 0, spDialog: false });
  };

  closeBldDialog = (val) => {
    console.log(val);

    const self = this;
    const { bldId } = this.state;
    const { dispatch } = this.props;

    const post_data = {};

    if (val.address) post_data.address = val.address;
    if (val.name) post_data.name = val.name;
    if (val.email) post_data.email = val.email;
    if (val.name_i18n) post_data.name_i18n = val.name_i18n;
    if (val.description_i18n) post_data.description_i18n = val.description_i18n;
    if (val.description || val.description == "")
      post_data.description = val.description;

    if (bldId == 0) {
      if (val.comment || val.comment == "") post_data.comment = val.comment;
      if (val.person || val.person == "") post_data.persons = val.person;
      if (val.phone || val.phone == "") post_data.phone = val.phone;
    }

    if (post_data && post_data.name) {
      if (bldId > 0) {
        userService.patchWrapperBody(
          `api/building/${bldId}`,
          post_data,
          (data) => {
            if (data.status == 200) self.getBuildings();
          },
          (error) => {
            if (error != "") {
              self.setState({ error, isLoading: false });
              dispatch(userActions.set_error(error, "error"));
            }
          }
        );
      } else {
        userService.postWrapper(
          "api/building",
          post_data,
          (data) => {
            if (data.status === 200) self.getBuildings();
          },
          (error) => {
            if (error !== "") {
              self.setState({ error, isLoading: false });
              dispatch(userActions.set_error(error, "error"));
            }
          }
        );
      }

      this.setState({ bldDialog: false });
    } else {
      this.setState({ bldDialog: false });
    }
  };

  onRequisitesSaved = (data) => {
    const self = this;
    const { dispatch, user } = this.props;
    if (data && data.data) {
      user.info = { ...user.info, ...data.data };
      localStorage.setItem("user", JSON.stringify(user.info));
      dispatch(userActions.setuser(data.data));
    }
    const pending = self.state.pendingPublish;
    self.setState(
      { showRequisitesDialog: false, pendingPublish: 0, requiredFields: null },
      () => {
        if (pending === 1) {
          self.saveConf(1);
        }
      }
    );
  };

  closeRequisitesDialog = () => {
    this.setState({
      showRequisitesDialog: false,
      pendingPublish: 0,
      requiredFields: null,
    });
  };

  createTranslation = (type, id, afterCreate) => {
    let self = this;

    userService.postWrapper(
      "api/translation?entity_type=" + type + "&entity_id=" + id,
      {},
      (data) => afterCreate(data.data),
      (error) => {
        if (error != "") {
          self.setState({ error });
        }
      }
    );
  };

  delTranslation = (type, id) => {
    let self = this;

    userService.delWrapper(
      "api/translation?entity_type=" + type + "&entity_id=" + id,
      () => {},
      (error) => {
        if (error != "") {
          self.setState({ error });
        }
      }
    );
  };

  stateSetter = (key, value) => {
    this.setState({ [key]: value });
  };

  render() {
    const self = this;
    const {
      id,
      bldAddr,
      sponsors,
      sp_list,
      spId,
      spDialog,
      image,
      streamUrl,
      bldDialog,
      bldId,
      dName,
      dNameI18N,
      dDesc,
      dDescI18N,
      dEmail,
      dAddress,
      selectedBldId,
      start_time,
      end_time,
      start_date,
      end_date,
      blds,
      format,
      part_count,
      spons_count,
      name,
      is_published,
      urlt,
      brief,
      langList,
      allLang,
      name_i18n,
      contacts,
      description,
      contacts_i18n,
      description_i18n,
      faq,
      wifi,
      faq_i18n,
      wifi_i18n,
      questionable,
      online_support,
      hidden_without_tickets,
      isMultilang,
      premiumState,
      translation,
      domain,
      metrics,
      external_ticket_url,
      ai_text,
    } = this.state;

    const { activeTab } = this.state;
    const { selectedConf, isConfSelected } = this.props.user;
    // В Китае генерации сайта нет, а без неё остаётся одна вкладка — переключатель не нужен.
    const showSiteTab = id > 0 && process.env.REACT_APP_CHINA_MODE !== "true";

    let conf_url =
      window.location.protocol + "//" + window.location.host + "/event/" + id;

    console.log("DESC", description);

    const renderActionButtons = (position) => (
      <div
        className="layout__block-btns create-conf-action-buttons"
        style={
          position === "top"
            ? { marginTop: 0, paddingTop: 0, paddingBottom: 24 }
            : { paddingBottom: 220 }
        }
      >
        <div className="layout__block-btn">
          <button
            className="btn btn--border"
            type="button"
            onClick={() => this.setState({ showCardPreview: true })}
          >
            {i18next.t("preview")}
          </button>
        </div>
        <div className="layout__block-btn">
          <button
            className="btn btn--border"
            type="button"
            onClick={this.resetConf}
          >
            {i18next.t("reset")}
          </button>
        </div>

        <div className="layout__block-btn">
          {id == 0 && (
            <button
              onClick={this.onAdd}
              className="btn"
              type="submit"
            >
              {i18next.t("save_conf")}
            </button>
          )}
          {id > 0 && (
            <button
              onClick={this.onSave}
              className="btn"
              type="submit"
            >
              {i18next.t("save_conf")}
            </button>
          )}
        </div>
        <div className="layout__block-btn">
          <button
            onClick={() => this.onPublic(1 - is_published)}
            className={id > 0 ? "btn" : "btn_disabled"}
            type="submit"
            title={id > 0 ? "" : i18next.t("save_first")}
          >
            {is_published == 0
              ? i18next.t("event_publish")
              : i18next.t("event_disable_publish")}
          </button>
        </div>
      </div>
    );

    return (
      <div className="layout__wrap">
        {isConfSelected && !selectedConf && (
          <ConferenceNotSelected page={"conf_param"} isGlobalSelector={true} />
        )}
        {(!isConfSelected || selectedConf) && (
          <div className="create-conf-page">
            {showSiteTab && (
              <div className="tab-switcher" style={{ marginBottom: 16, marginLeft: 30, marginTop: 20 }}>
                <ul>
                  <li
                    className={activeTab === 0 ? "active" : ""}
                    onClick={() => this.setState({ activeTab: 0 })}
                  >
                    {i18next.t("tab_main")}
                  </li>
                  <li
                    className={activeTab === 1 ? "active" : ""}
                    onClick={() => this.setState({ activeTab: 1 })}
                  >
                    {i18next.t("tab_conf_site")}
                  </li>
                </ul>
              </div>
            )}

            {activeTab === 0 && (
          <div className="layout__cols">
            <div
              className="layout__block"
              style={{ flex: 1, marginLeft: 30, marginRight: 30 }}
            >
              {renderActionButtons("top")}
              <div className="form">
                <div className="form__col">
                  <div
                    className="create-conf-cols"
                    style={{
                      display: "flex",
                      flex: 1,
                      flexDirection: "row",
                      justifyContent: "space-around",
                      alignItems: "stretch",
                    }}
                  >
                    <div
                      style={{
                        width: "48%",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div className="form__group">
                        <LabelHint title="event_name" hint="hint_event_name" />

                        <InputI18N
                          id="text1"
                          type="text"
                          className="form__input"
                          name="name"
                          value={isMultilang ? name_i18n ?? {} : name}
                          onChange={this.handleChangeI18N}
                          placeholder={i18next.t("event_name")}
                          langList={langList}
                          isMultilang={isMultilang}
                        />
                      </div>

                      <div
                        className="form__group"
                        style={{ flex: 1, display: "flex", flexDirection: "column" }}
                      >
                        <span className="form__label">
                          {i18next.t("image")}
                        </span>
                        <div style={{ flex: 1, minHeight: 250 }}>
                          <DropFile
                            onDrop={this.onDrop}
                            image={image}
                            size="fill"
                          />
                        </div>
                      </div>
                    </div>

                    <div style={{ width: "48%" }}>
                      <div className="form__group">
                        <LabelHint title="event_dates" hint="hint_event_dates" />

                        <div className="form__group-body">
                          <div
                            className="date-wrap form__group-row"
                            style={{
                              display: "flex",
                              gap: 10,
                              alignItems: "center",
                            }}
                          >
                            <label
                              htmlFor="start-date"
                              style={{ width: 130, flexShrink: 0 }}
                            >
                              {i18next.t("date_start")}
                            </label>
                            <input
                              required
                              type="date"
                              className="form__input"
                              style={{ flex: 1 }}
                              id="start-date"
                              value={start_date}
                              name="trip-start"
                              onChange={(e) => this.changeDate(0, e)}
                            />
                            <input
                              type="time"
                              value={start_time}
                              class="form__input"
                              style={{ flex: 1 }}
                              name="trip-start"
                              onChange={(e) => this.changeTime(0, e)}
                            />
                          </div>

                          <div
                            className="date-wrap form__group-row"
                            style={{
                              display: "flex",
                              gap: 10,
                              alignItems: "center",
                            }}
                          >
                            <label
                              htmlFor="end-date"
                              style={{ width: 130, flexShrink: 0 }}
                            >
                              {i18next.t("date_end")}
                            </label>
                            <input
                              required
                              type="date"
                              className="form__input"
                              style={{ flex: 1 }}
                              id="end-date"
                              value={end_date}
                              name="trip-start"
                              onChange={(e) => this.changeDate(1, e)}
                            />
                            <input
                              type="time"
                              value={end_time}
                              class="form__input"
                              style={{ flex: 1 }}
                              name="trip-start"
                              onChange={(e) => this.changeTime(1, e)}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="form__group">
                        <LabelHint
                          title="event_format"
                          hint="hint_event_format"
                        />

                        <div className="radio-buttons">
                          <div
                            className="radio-button"
                            onClick={() => self.setState({ format: "online" })}
                          >
                            <span
                              id="r1"
                              name="category"
                              class={
                                format === "online"
                                  ? "radio-button__checked"
                                  : "radio-button__part"
                              }
                            >
                              {i18next.t("online_text")}
                            </span>
                          </div>
                          <div
                            className="radio-button"
                            onClick={() => self.setState({ format: "hybrid" })}
                          >
                            <span
                              id="r2"
                              name="category"
                              class={
                                format === "hybrid"
                                  ? "radio-button__checked"
                                  : "radio-button__part"
                              }
                            >
                              {i18next.t("hybrid_text")}
                            </span>
                          </div>
                          <div
                            className="radio-button"
                            onClick={() => self.setState({ format: "offline" })}
                          >
                            <span
                              id="r3"
                              name="category"
                              class={
                                format === "offline"
                                  ? "radio-button__checked"
                                  : "radio-button__part"
                              }
                            >
                              {i18next.t("offline_text")}
                            </span>
                          </div>
                        </div>
                      </div>

                      {format !== "offline" && (
                        <div className="form__group">
                          <TranslationSettings
                            translation={translation}
                            translationUrl={urlt}
                            setTranslationUrl={(url) =>
                              this.setState({ urlt: url })
                            }
                            createTranslation={(afterCreate) =>
                              self.createTranslation(
                                "conference",
                                id,
                                afterCreate
                              )
                            }
                            delTranslation={() =>
                              self.delTranslation("conference", id)
                            }
                            delayedCreation={
                              id == 0 &&
                              ((value) =>
                                this.setState({
                                  createTranslationForNewConference: value,
                                }))
                            }
                            hint="translation_settings_hint"
                          />
                        </div>
                      )}

                      {format !== "online" && (
                        <div class="form__group">
                          <div
                            style={{
                              flexDirection: "row",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <LabelHint
                              title="event_addres"
                              hint="hint_event_addres"
                            />
                            <div class="form__group-top">
                              <button
                                type="button"
                                class="form__btn"
                                onClick={this.addAddr}
                              >
                                <svg width="29" height="29">
                                  <use href="./img/sprite.svg#add-icon"></use>
                                </svg>
                                <span>{i18next.t("btn_add")}</span>
                              </button>
                            </div>
                          </div>

                          <div class="form__group-body">
                            <div
                              style={{
                                display: "flex",
                                flex: 1,
                                flexDirection: "row",
                              }}
                            >
                              <Select
                                // flex вместо width: 100% — иначе селект занимает
                                // всю строку и выталкивает корзину за край экрана.
                                // minWidth: 0 обязателен: без него flex-элемент
                                // не даёт себя сжать ниже ширины содержимого.
                                style={{ flex: 1, minWidth: 0 }}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectedBldId}
                                onChange={(e) => this.setBld(e.target.value)}
                                MenuProps={{
                                  anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "right",
                                  },
                                }}
                              >
                                {blds.length > 0 &&
                                  blds.map((item, index) => (
                                    <MenuItem
                                      value={item.id}
                                      style={{
                                        // На телефоне 20vw — это около 80px, и адрес
                                        // площадки обрезался до пары символов.
                                        maxWidth: "min(400px, 80vw)",
                                      }}
                                    >
                                      {item.address}{" "}
                                      {item.name ? "(" + item.name + ")" : ""}{" "}
                                    </MenuItem>
                                  ))}
                              </Select>
                              <div
                                style={{
                                  width: 20,
                                  paddingLeft: 10,
                                  marginTop: 10,
                                  flexShrink: 0,
                                }}
                              >
                                <DeleteIcon
                                  onClick={() =>
                                    self.setState({ selectedBldId: null })
                                  }
                                  width="15"
                                  height="15"
                                />
                              </div>
                            </div>
                            {selectedBldId > 0 && (
                              <button
                                type="button"
                                class="form__btn"
                                onClick={(e) => this.editAddr(selectedBldId)}
                              >
                                <span>{i18next.t("btn_edit")}</span>
                                <svg width="29" height="29" fill="none"></svg>
                              </button>
                            )}
                            {selectedBldId > 0 && (
                              <button
                                type="button"
                                class="form__btn"
                                onClick={(e) => this.deleteAddr(selectedBldId)}
                              >
                                <span>{i18next.t("btn_delete")}</span>
                                <svg width="29" height="29" fill="none"></svg>
                              </button>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <TicketTypeList
                    conferenceId={this.state.id}
                    loadingTickets={this.state.loadingTickets}
                    stateSetter={this.stateSetter}
                    dispatch={this.props.dispatch}
                    ticketTypes={this.state.tickets_tmp}
                    isMultilang={this.state.isMultilang}
                    langList={this.state.langList}
                    premiumState={this.state.premiumState}
                    allAnketaFields={this.state.allAnketaFields}
                    getTickets={this.getTickets}
                  />

                  <Collapsed title={i18next.t("advanced_settings")} content={<div>
                    <div className="form__group">
                      <LabelHint
                        title="org_contacts"
                        hint="hint_org_contacts"
                      />

                      <TextAreaI18N
                        id="area1"
                        className="form__input"
                        placeholder={i18next.t("text")}
                        name="contacts"
                        multiline
                        onChange={this.handleChangeI18N}
                        value={isMultilang ? contacts_i18n ?? {} : contacts}
                        langList={langList}
                        isMultilang={isMultilang}
                      />
                    </div>

                    <div className="form__group">
                      <LabelHint title="event_desc" hint="hint_event_desc" />
                      <TabEditor
                        onChange={this.descChange}
                        value={
                          isMultilang ? description_i18n ?? {} : description
                        }
                        langList={langList}
                        isMultilang={isMultilang}
                      />
                    </div>

                    <div style={{ flexDirection: "row", display: "flex" }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            style={{ marginRight: -15 }}
                            color="default"
                            checked={hidden_without_tickets == 1}
                            onClick={() =>
                              self.setState({
                                hidden_without_tickets:
                                  1 - hidden_without_tickets,
                              })
                            }
                          />
                        }
                      />

                      <LabelHint
                        title="hidden_without_tickets"
                        hint="hint_hidden_without_tickets"
                      />
                    </div>

                    {/* Две колонки: на телефоне они складываются в одну — иначе
                        подписи чекбоксов и блока Wi-Fi наезжают друг на друга. */}
                    <div className="conf-columns">
                      <div className="conf-columns__col">
                        <div className="form__group">
                          <FormGroup>
                            <div
                              style={{ flexDirection: "row", display: "flex" }}
                            >
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    style={{ marginRight: -15 }}
                                    color="default"
                                    checked={questionable == 1}
                                    onClick={() =>
                                      self.setState({
                                        questionable: 1 - questionable,
                                      })
                                    }
                                  />
                                }
                              />
                              <LabelHint
                                title="questions_enabled"
                                hint="hint_questions_enabled"
                              />
                            </div>
                          </FormGroup>
                        </div>

                        {/* Чат посетителей с организатором (Live Helper Chat); в китайской
                            сборке и без сервера чата его нет вовсе. */}
                        {lhcUrl && process.env.REACT_APP_CHINA_MODE !== "true" && (
                          <div className="form__group">
                            <FormGroup>
                              <div
                                style={{ flexDirection: "row", display: "flex" }}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      style={{ marginRight: -15 }}
                                      color="default"
                                      checked={online_support == 1}
                                      onClick={() =>
                                        self.setState({
                                          online_support: 1 - online_support,
                                        })
                                      }
                                    />
                                  }
                                />
                                <LabelHint
                                  title="online_support"
                                  hint="hint_online_support"
                                />
                              </div>
                            </FormGroup>
                          </div>
                        )}

                        <div className="form__group">
                          <div className="form__group-row">
                            <label htmlFor="text2" className="form__label">
                              {i18next.t("part_count")}: {part_count}
                            </label>
                          </div>

                          {id > 0 && (
                            <div class="form__group-top">
                              <span class="form__label">
                                {i18next.t("sponsors")}
                              </span>

                              <EditButton
                                onClick={self.editSponsors}
                                width="15"
                                height="15"
                              />
                            </div>
                          )}
                        </div>

                        {selectedConf &&
                          selectedConf.id > 0 &&
                          !(
                            premiumState &&
                            (premiumState.status === "disabled_in_tariff" ||
                              premiumState.status === "conference_finished")
                          ) && (
                            <div className="form__group">
                              <LabelHint
                                title="event_restrictions"
                                hint="hint_event_restrictions"
                              />
                              {this.state.confLimits}
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                {/* Блок по статусу canBePremium: запрос имеет смысл только
                                    при ok/low_balance, при остальных статусах он ничего
                                    не даст (PremiumConferenceOption::canUseOption на бэке) */}
                                {premiumState && premiumState.status === "ok" && (
                                  <div className="layout__block-btn">
                                    <button
                                      className="btn btn--border"
                                      type="button"
                                      onClick={this.setPremium}
                                    >
                                      {i18next.t("set_premium_for", {
                                        price:
                                          Number(premiumState.price) +
                                          " " +
                                          currencySymbol,
                                      })}
                                    </button>
                                  </div>
                                )}
                                {premiumState && premiumState.status === "low_balance" && (
                                  <div className="layout__block-btn">
                                    {/* Кнопку показываем неактивной, чтобы цена оставалась
                                        видимой; причина — в title и в тексте под кнопкой */}
                                    <button
                                      className="btn_disabled"
                                      disabled
                                      type="button"
                                      title={i18next.t("premium_state_low_balance")}
                                    >
                                      {i18next.t("set_premium_for", {
                                        price:
                                          Number(premiumState.price) +
                                          " " +
                                          currencySymbol,
                                      })}
                                    </button>
                                  </div>
                                )}
                                {premiumState && premiumState.status === "already" && (
                                  <div>
                                    {i18next.t("premium_until", {
                                      date: this.premiumUntilDate(),
                                    })}
                                  </div>
                                )}
                              </div>
                              {premiumState && premiumState.status === "ok" && (
                                <div style={{ fontSize: 12, marginTop: 4, opacity: 0.7 }}>
                                  {i18next.t("premium_explanation")}
                                </div>
                              )}
                              {premiumState && premiumState.status === "low_balance" && (
                                <div style={{ fontSize: 12, marginTop: 4 }}>
                                  {this.lowBalanceHint()}
                                </div>
                              )}
                            </div>
                          )}

                        {!!this.props.user.info.multilanguage && (
                          <div className="form__group">
                            <LabelHint
                              title="event_lang"
                              hint="hint_event_lang"
                            />
                            <FormGroup>
                              {Object.keys(allLang).map((item) => (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      color="default"
                                      checked={langList.indexOf(item) >= 0}
                                      onClick={() => self.clickLangItem(item)}
                                    />
                                  }
                                  label={allLang[item]}
                                />
                              ))}
                            </FormGroup>
                          </div>
                        )}

                        {0 > 1 && (
                          <div className="form__group">
                            <label htmlFor="area1" className="form__label">
                              {i18next.t("quest_and_answers")}
                            </label>

                            <TextAreaI18N
                              id="area1"
                              className="form__input"
                              placeholder={i18next.t("text")}
                              name="faq"
                              onChange={this.handleChangeI18N}
                              value={isMultilang ? faq_i18n ?? {} : faq}
                              langList={langList}
                              isMultilang={isMultilang}
                            />
                          </div>
                        )}
                      </div>
                      <div className="conf-columns__col">
                        <div className="form__group">
                          <LabelHint
                            title="inet_on_site"
                            hint="hint_inet_on_site"
                          />

                          <textarea
                            id="area1"
                            className="form__input"
                            placeholder={i18next.t("text")}
                            name="wifi"
                            onChange={this.handleChange}
                            value={wifi}
                          ></textarea>
                        </div>
                        <div className="form__group">
                          <LabelHint
                            title="brief_for_speakers"
                            hint="hint_brief_for_speakers"
                          />
                          <textarea
                            id="area1"
                            className="form__input"
                            placeholder={i18next.t("text")}
                            name="brief"
                            onChange={this.handleChange}
                            value={brief}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    {process.env.REACT_APP_CHINA_MODE !== "true" && (
                      <div className="form__group">
                        <LabelHint title="conf_ai_text" hint="hint_conf_ai_text" />
                        <textarea
                          className="form__input"
                          placeholder={i18next.t("text")}
                          name="ai_text"
                          rows={6}
                          onChange={this.handleChange}
                          value={ai_text}
                        ></textarea>
                      </div>
                    )}
                    <div className="form__group">
                      <LabelHint
                        title="external_ticket_url"
                        hint="hint_external_ticket_url"
                      />
                      <TextField
                        variant="outlined"
                        title={i18next.t("external_ticket_url")}
                        placeholder="https://"
                        value={external_ticket_url}
                        onChange={(e) =>
                          this.setState({
                            external_ticket_url: e.target.value,
                          })
                        }
                      />
                    </div>
                    {process.env.REACT_APP_CHINA_MODE !== "true" && (
                      <>
                        <div className="form__group">
                          <LabelHint
                            title="event_domain"
                            hint="event_domain_hint"
                          />
                          <TextField
                            variant="outlined"
                            title={i18next.t("event_domain")}
                            value={domain}
                            onChange={(e) =>
                              this.setState({ domain: e.target.value })
                            }
                          />
                        </div>
                        {domain && (
                          <div className="form__group">
                            <LabelHint
                              title="event_metrics"
                              hint="event_metrics_hint"
                            />
                            <textarea
                              variant="outlined"
                              title={i18next.t("event_metrics")}
                              value={metrics}
                              onChange={(e) =>
                                this.setState({ metrics: e.target.value })
                              }
                            />
                          </div>
                        )}
                      </>
                    )}
                  </div>}/>

                  {renderActionButtons("bottom")}
                </div>
              </div>
            </div>
          </div>
            )}

            {activeTab === 1 && showSiteTab && (
              <AILandingPage conferenceId={id} />
            )}
          </div>
        )}
        <BldDialog
          handleClose={self.closeBldDialog}
          id={bldId}
          dAddress={dAddress}
          dName={dName}
          dNameI18N={dNameI18N}
          dDesc={dDesc}
          dDescI18N={dDescI18N}
          dEmail={dEmail}
          dialogOpen={bldDialog}
          isMultilang={isMultilang}
          langList={langList}
        />

        <Dialog
          open={this.state.showCardPreview}
          onClose={() => this.setState({ showCardPreview: false })}
          maxWidth="xs"
          fullWidth
          PaperProps={{ style: { overflowY: "visible" } }}
        >
          <DialogTitle>{i18next.t("preview")}</DialogTitle>
          <DialogContent style={{ overflowY: "visible" }}>
            <ul className="conf-list" style={{ margin: 0, padding: 0 }}>
              <ConfItem
                preview
                data={this.getPreviewCardData()}
                onClick={() => {}}
                onEdit={() => {}}
                onSchedule={() => {}}
                onDelete={() => {}}
              />
            </ul>
          </DialogContent>
          <DialogActions>
            <button
              className="btn btn--border"
              type="button"
              onClick={() => this.setState({ showCardPreview: false })}
            >
              {i18next.t("btn_cancel")}
            </button>
          </DialogActions>
        </Dialog>

        <SponsorDialog
          handleClose={self.closeSpDialog}
          id={spId}
          sp_list={sponsors}
          all_list={sp_list}
          dialogOpen={spDialog}
        />
        <RequisitesDialog
          open={this.state.showRequisitesDialog}
          onClose={this.closeRequisitesDialog}
          onSaved={this.onRequisitesSaved}
          mandatory={this.state.pendingPublish === 1}
          required_fields={this.state.requiredFields}
          all_requisites={this.props.user.info.all_requisites}
          current_requisites={this.props.user.info.requisites}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { app, user, authentication } = state;

  return {
    user,
    app,
    authentication,
  };
}

const connectedCreateConfPage = connect(mapStateToProps)(CreateConfPage);
export { connectedCreateConfPage as CreateConfPage };
